module.exports = __webpack_public_path__ + "img/Group 27996.ec86bfa0.png";